import { useRecoilValue } from 'recoil';
import { useFeedback } from '../../../hooks/useFeedback';
import { useStyles } from '../../../hooks/useStyles';
import { getAvailableCommands, getCommandList, getCommands } from '../../../services/commandService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import { CommandCategory } from '../../../types/availableCommand';

export function useCommands() {
  const { theme } = useStyles();
  const apiParams = useRecoilValue(apiParamsState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const { showFailFeedback } = useFeedback();

  const loadCommands = async (page: number, commandType?: string, status?: string, assetId?: string) => {
    if (!apiParams) return;
    const { commands, error, total } = await getCommands(
      page,
      apiParams.clientId,
      isAllWorkspacesSelected ? undefined : apiParams.subClientId,
      assetId,
      status,
      commandType
    );
    return {
      commands,
      error,
      total,
    };
  };

  const getDevicesCommandsByAsset = async (assetId: string, commandCategory?: CommandCategory) => {
    const { devices, error } = await getAvailableCommands(assetId, commandCategory);
    if (!error && devices) {
      return devices;
    } else {
      showFailFeedback(error || 'Ocurrió un error, inténtalo más tarde.');
    }
  };

  const getAllAvailableCommands = async () => {
    if (!apiParams) return;
    const { availableCommands, error } = await getCommandList(apiParams.clientId, apiParams.subClientId);
    if (!error && availableCommands) {
      return availableCommands;
    }
  };

  const getCommandStatusColor = (status?: string) => {
    if (status === 'success') return theme.colors.positive;
    if (status === 'pending') return theme.colors.warning;
    if (status === 'expired') return theme.colors.negative;
    return theme.colors.contentSecondary;
  };

  return {
    getAllAvailableCommands,
    getDevicesCommandsByAsset,
    getCommandStatusColor,
    loadCommands,
  };
}
